export interface EnumOptionControlProps {
  valueLabel: string
  onPrevious: () => void
  onNext: () => void
  squareButtonClassName: string
  valuePillClassName: string
  registerPreviousButton?: (el: HTMLButtonElement | null) => void
  registerNextButton?: (el: HTMLButtonElement | null) => void
}

export function EnumOptionControl({
  valueLabel,
  onPrevious,
  onNext,
  squareButtonClassName,
  valuePillClassName,
  registerPreviousButton,
  registerNextButton,
}: EnumOptionControlProps) {
  return (
    <>
      <button ref={registerPreviousButton} tabIndex={-1} className={squareButtonClassName} onClick={onPrevious}>
        ‹
      </button>
      <div className={valuePillClassName}>{valueLabel}</div>
      <button ref={registerNextButton} tabIndex={-1} className={squareButtonClassName} onClick={onNext}>
        ›
      </button>
    </>
  )
}

